import { render, staticRenderFns } from "./func-modify.vue?vue&type=template&id=65b9aeb0&scoped=true"
import script from "./func-modify.vue?vue&type=script&lang=js"
export * from "./func-modify.vue?vue&type=script&lang=js"
import style0 from "./func-modify.vue?vue&type=style&index=0&id=65b9aeb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b9aeb0",
  null
  
)

export default component.exports